// baseQueryWithAuth.js

import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { baseURL } from "../../api";
// Note: You don't need to import FetchBaseQueryError here

const rawBaseQuery = fetchBaseQuery({
  baseUrl: baseURL,
  // ... (prepareHeaders remains the same)
  prepareHeaders: (headers, { getState }) => {
    // ... (logic to set Authorization header)
    const token = getState().auth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});


export const baseQueryWithAuth = async (args, api, extraOptions) => {
  const isBinary = args.meta?.isBinary;
  
  // If it's a binary file, use a custom fetch call
  if (isBinary) {
    const url = `${baseURL}${args.url}`; // Use your imported baseURL
    
    // 1. Prepare headers (including Auth token)
    const headers = new Headers();
    const token = api.getState().auth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    try {
      const response = await fetch(url, {
        method: args.method || 'GET',
        headers: headers,
      });

      if (!response.ok) {
        // Handle server errors
        return {
          error: {
            status: response.status,
            data: await response.json().catch(() => ({ message: 'Server error' })),
          },
        };
      }
      
      // 2. CRITICAL: Return the response body as a BLOB immediately.
      const pdfBlob = await response.blob(); 
      return { data: pdfBlob }; // RTK Query receives the Blob directly
      
    } catch (error) {
      return { error: { status: 'FETCH_ERROR', data: error.message } };
    }
  }

  // 3. For non-binary (standard) requests, use the default logic
  return rawBaseQuery(args, api, extraOptions);
};